import React from 'react';
import { StoreOption } from './Index';
import StoreSelect from './StoreSelect';

type Props = {
    open: boolean;
    email: string;
    scopes: string[];
    isActive: boolean;
    allScopes: string[];
    onEmailChange: (v: string) => void;
    onToggleScope: (scope: string) => void;
    onToggleActive: () => void;
    onClose: () => void;
    onSubmit: (e: React.FormEvent) => void;
    submitting: boolean;
    feedback: { type: 'success' | 'error' | ''; text: string };
    stores: StoreOption[];
    storeId: number;
    onStoreChange: (v: number) => void;
};

export function UserEditModal({
    open, email, scopes, isActive, allScopes, onEmailChange, onToggleScope,
    onToggleActive, onClose, onSubmit, submitting, feedback, stores, storeId, onStoreChange
}: Props) {
    if (!open) return null;

    return (
        <div className="modal" onClick={onClose}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <h2>Edit user</h2>
                <form onSubmit={onSubmit}>
                    <div className="scroll-area">
                        <div className="form-field">
                            <input
                                className="control"
                                type="email"
                                placeholder="user@domain.com"
                                value={email}
                                onChange={(e) => onEmailChange(e.target.value)}
                                required
                            />
                        </div>

                        <div className="form-field">
                            <label>Store</label>
                            <StoreSelect
                                options={stores}
                                value={storeId}
                                onChange={onStoreChange}
                            />
                        </div>

                        <div className="scopes-expanded">
                            {allScopes.map(sc => (
                                <label key={sc} className="chk">
                                    <input
                                        type="checkbox"
                                        checked={scopes.includes(sc)}
                                        onChange={() => onToggleScope(sc)}
                                    />
                                    <span>{sc}</span>
                                </label>
                            ))}
                        </div>

                        <div className="status-row" role="group" aria-label="Account status">
                            <div className="label">
                                <span>Account status</span>
                                <span className={`pill ${isActive ? 'on' : 'off'}`}>
                                    {isActive ? 'Active' : 'Inactive'}
                                </span>
                            </div>
                            <label
                                className={`switch ${isActive ? 'on' : ''}`}
                                aria-checked={isActive}
                                role="switch"
                                tabIndex={0}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        onToggleActive();
                                    }
                                }}
                            >
                                <input
                                    type="checkbox"
                                    checked={isActive}
                                    onChange={onToggleActive}
                                    aria-label="Toggle account status"
                                />
                                <span className="thumb" />
                            </label>
                            <div className="hint">
                                {isActive
                                    ? 'Active users can sign in and access the portal.'
                                    : 'Inactive users cannot sign in until re-enabled.'}
                            </div>
                        </div>
                    </div>

                    {feedback.text && (
                        <div className={`feedback-message ${feedback.type}`}>{feedback.text}</div>
                    )}

                    <div className="modal-actions">
                        <button
                            className={`btn-primary ${submitting ? 'loading' : ''}`}
                            type="submit"
                            disabled={submitting}
                        >
                            {submitting ? 'Saving...' : 'Save changes'}
                        </button>
                        <button
                            className="btn-secondary"
                            type="button"
                            onClick={onClose}
                            disabled={submitting}
                        >
                            Close
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
